import { CustomMaterialEnumControl } from './CustomEnumControl'
import { withJsonFormsCellProps, withTranslateProps } from '@jsonforms/react'

const CustomEnumCell = withJsonFormsCellProps(
    withTranslateProps(CustomMaterialEnumControl)
)
export default CustomEnumCell
